/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_locals': {
    width: 16,
    height: 16,
    viewBox: '0 0 21 18.421',
    data: '<path pid="0" d="M17.15 18.374c-.525-.174-.788-.7-1.225-1.049a3.051 3.051 0 00-4.288.437c-.437.438-.612.612-1.137.612s-.7-.174-1.138-.612A3.216 3.216 0 007 16.625a3.074 3.074 0 00-2.363 1.137c-.437.438-.612.612-1.137.612s-.7-.174-1.138-.612A3.216 3.216 0 000 16.625v-3.5c1.75 0 1.75 1.75 3.5 1.75s1.749-1.75 3.5-1.75 1.75 1.75 3.5 1.75 1.749-1.75 3.5-1.75 1.75 1.75 3.5 1.75 1.75-1.75 3.5-1.75v3.5a3.22 3.22 0 00-2.363 1.137 1.729 1.729 0 01-1.171.658 1.129 1.129 0 01-.316-.046zm-4.025-6.124V10.5H7v1.75H5.25V4.375A4.333 4.333 0 019.624 0h1.75v1.75h-1.75A2.577 2.577 0 007 4.375v.875h6.125v-.875A4.333 4.333 0 0117.5 0h1.75v1.75H17.5a2.577 2.577 0 00-2.625 2.624v7.876zM7 8.75h6.125V7H7z" _fill="#fff"/>'
  }
})
